import { render, staticRenderFns } from "./AddMaterial.vue?vue&type=template&id=a640e56e&scoped=true"
import script from "./AddMaterial.vue?vue&type=script&lang=js"
export * from "./AddMaterial.vue?vue&type=script&lang=js"
import style0 from "./AddMaterial.vue?vue&type=style&index=0&id=a640e56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a640e56e",
  null
  
)

export default component.exports